module.exports = __webpack_public_path__ + "static/media/polytope_52_3_5_layers_2_5.5abeb125.gif";